<template>
  <div>
    <el-card class="mat12 media_row_card">
      <el-row>
        <el-col :span="6" class="padding-tb10 flex_class media_col">
          <h4 class="flex_shrink">员工编号：</h4>
          <span
            :class="$store.getters.tagsView?'ellipsis':''"
            :title="detail.code"
          >{{ detail.code }}</span>
        </el-col>
        <el-col :span="6" class="padding-tb10 flex_class media_col">
          <h4 class="flex_shrink">姓名：</h4>
          <span
            :class="$store.getters.tagsView?'ellipsis':''"
            :title="detail.name"
          >{{ detail.name }}</span>
        </el-col>

        <el-col :span="6" class="padding-tb10 flex_class media_col">
          <h4 class="flex_shrink">年龄：</h4>
          <span
            :class="$store.getters.tagsView?'ellipsis':''"
            :title="detail.birthday | getAge"
          >{{detail.birthday|getAge}}</span>
        </el-col>

        <el-col :span="6" class="padding-tb10 flex_class media_col">
          <h4 class="flex_shrink">所属公司：</h4>
          <span
            :class="$store.getters.tagsView?'ellipsis':''"
            :title="getCompany(detail.companyId)"
          >{{getCompany(detail.companyId) }}</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6" class="padding-tb10 flex_class media_col" v-if="join">
          <h4 class="flex_shrink">提交时间：</h4>
          <span :class="$store.getters.tagsView?'ellipsis':''" :title="detail.createDate">{{detail.createDate ? detail.createDate : detail.updateTime }}</span>
        </el-col>
        <el-col :span="6" class="padding-tb10 flex_class media_col" v-if="detail.contractBeginTime&& detail.contractEndTime">
          <h4 class="flex_shrink">合同期限：</h4>
          <span :class="$store.getters.tagsView?'ellipsis':''" >{{detail.contractBeginTime}}至{{detail.contractEndTime}}</span>
        </el-col>
        <el-col :span="12" class="padding-tb10 flex_class media_col">
          <h4 class="flex_shrink">所在项目：</h4>
          <span :class="$store.getters.tagsView?'ellipsis':''">{{ detail.projectName}}</span>
        </el-col>

      </el-row>
      <el-row>
        <el-col :span="6" class="padding-tb10 flex_class media_col" v-if="detail.leaveDate">
          <h4 class="flex_shrink">拟离职时间：</h4>
          <span
            :class="$store.getters.tagsView?'ellipsis':''"
            :title="detail.leaveDate"
          >{{ detail.leaveDate }}</span>
        </el-col>
         <el-col :span="6" class="padding-tb10 flex_class media_col" v-if="detail.quitTime">
          <h4 class="flex_shrink">离职时间：</h4>
          <span
            :class="$store.getters.tagsView?'ellipsis':''"
            :title="detail.quitTime"
          >{{ detail.quitTime }}</span>
        </el-col>
        <el-col :span="6" class="padding-tb10 flex_class media_col">
          <h4 class="flex_shrink">离职类型：</h4>
          <span :class="$store.getters.tagsView?'ellipsis':''">{{ detail.quitType==2?'紧急离职':'正常离职'}}</span>
        </el-col>
        <el-col :span="12" class="padding-tb10 flex_class media_col">
          <h4 class="flex_shrink">离职原因：</h4>
          <span
            :class="$store.getters.tagsView?'ellipsis':''"
            :title="detail.reason"
          >{{ detail.reason }}</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="20" class="padding-tb10">
          <router-link
            :to="{name:'employee_details',params:{id:detail.staffId}}"
            class="t_desc"
            tag="span"
          >查看详细资料&gt;&gt;</router-link>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "CardInfoBrief",
  props: {
    detail: {
      type: Object,
      default: {}
    },
    join:{ // 判断交接中的某些字段是否需要存在
      type:Boolean,
      default:true
    }
  },
  filters: {
    getAge(val) {
      var birthDayTime = new Date(val).getTime();
      var nowTime = new Date().getTime();
      return Math.ceil((nowTime - birthDayTime) / 31536000000) + "岁";
    }
  },
  methods: {
    // 获取公司列表
    getCompany(val) {
      let name = '';
      this.companyList = this.$store.state.company.companyList.slice();
      this.companyList.forEach(item => {
        if (item.id == val) {
          name = item.companyName;
        }
      });
      return name
    }
  }
};
</script>

<style lang="scss" scoped>
.t_desc {
  font-size: 14px;
  color: #409eff;
  cursor: pointer;
}
.leave_reson {
  padding-top: 23px;
  font-size: 14px;
  color: #333;
  .title {
    font-weight: bold;
  }
}
</style>
